/**
 *
 * @Info
 * As a rule of thumb we name the exported action
 * in CamelCaseCaps and the actual action value in camelCase.
 */

// GLOBAL
export const TestAction = 'testAction';
export const ClearStore = 'clearStore';

// AMP ACTIONS
export const ApplyChangeset = 'applyChangeSet';
export const CreateAmp = 'createAmp';
export const FetchAmps = 'fetchAmps';
export const FetchDraftAmps = 'fetchDraftAmps';
export const FetchFavoriteAmps = 'fetchFavoriteAmps';
export const FetchLiveAmps = 'fetchLiveAmps';
export const FetchEDetailAmps = 'fetchEDetailAmps';
export const GetAmpById = 'getAmpById';
export const DeleteAmpById = 'deleteAmpById';
export const CopyAmpById = 'copyAmpById';
export const AddToFavorites = 'addToFavorites';
export const RemoveFromFavorites = 'RemoveFromFavorites';
export const UpdateAmp = 'updateAmp';
export const GetRecentlyViewedAmps = 'getRecentlyViewedAmps';
export const SearchAmps = 'searchAmps';
export const DeleteConversationById = 'deleteConversationById';
export const SaveDeploymentSettings = 'saveDeploymentSettings';
export const DeleteDeploymentSettings = 'deleteDeploymentSettings';
export const UpdateDomainList = 'updateDomainList';
export const PublishAmp = 'publishAmp';
export const GetPublishedAmp = 'getPublishedAmp';
export const GetInstallationScript = 'getInstallationScrip';
export const VerifyInstallation = 'verifyInstallation';
export const VerifyDNS = 'verifyDNS';
export const ChangeAmpSortOrder = 'changeAmpSortOrder';
export const ChangeDraftAmpSortOrder = 'changeAmpSortOrder';
export const ChangeLiveAmpSortOrder = 'changeLiveAmpSortOrder';
export const ChangeFavoriteAmpSortOrder = 'changeFavoriteAmpSortOrder';
export const ResetMenu = 'resetMenu';
export const FetchTemplates = 'fetchTemplates';

// BUILDER STORE
export const ClearAddingNode = 'clearAddingNode';
export const AddSlideToConversation = 'addSlideToConversation';

// CONVERSATION ACTIONS
export const HandleConversationTitleChange = 'handleConversationTitleChange';
export const CreateNewConversation = 'createNewConversation';
export const AddStorageValue = 'addStorageValue';
export const DeleteStorageValue = 'deleteStorageValue';
export const UpdateStorageValue = 'updateStorageValue';
export const ReorderConversations = 'reorderConversations';

// TRIGGER ACTIONS
export const CreateTrigger = 'createTrigger';
export const UpdateTrigger = 'updateTirgger';
export const DeleteTriggerById = 'deleteTriggerById';

// NODE ACTIONS
export const AddNode = 'addNode';
export const UpdateNodeData = 'updateNodeData';
export const DeleteNodesById = 'deleteNodesById';
export const SafelyDeleteNodesById = 'safelyDeleteNodesById';
export const CopyNodes = 'copyNodes';
export const CutNodes = 'cutNodes';
export const PasteNodes = 'pasteNodes';

// MEDIA ACTIONS
export const FetchAmpFiles = 'fetchAmpFiles';
export const UploadAmpFile = 'uploadAmpFile';
export const DeleteAmpFile = 'deleteAmpFile';

// AUTH ACTIONS
export const SignUp = 'signUp';
export const Logout = 'logout';
export const SendResetPassword = 'sendResetPassword';
export const FetchOrganization = 'fetchOrganization';
export const UpdateOrganization = 'updateOrganization';
export const FetchUserData = 'fetchUserData';
export const UpdateUserData = 'updateUserData';
export const ChangePassword = 'changePassword';
export const OrgEnsured = 'orgEnsured';
export const FetchBilling = 'fetchBilling';
export const UpdateBilling = 'updateBilling';
export const FetchBillingPortalUrl = 'fetchBillingPortalUrl';
export const FetchBillingCheckoutUrl = 'fetchBillingCheckoutUrl';
export const FetchBillingPlans = 'fetchBillingPlans';
export const ChangeActiveOrganization = 'changeActiveOrganization';
export const FetchTaxIds = 'fetchTaxIds';
export const GetPlansQuota = 'getPlansQuota';

// BUILDER ACTIONS
export const Undo = 'undo';
export const Redo = 'redo';
export const AddToUndoStack = 'addToUndoStack';
export const SetCurrentConversation = 'setCurrentConversation';

// ADMINISTRATION ACTIONS
export const FetchMembers = 'fetchMembers';
export const InviteMembers = 'inviteMembers';
export const UpdateMembersRoles = 'updateMembersRoles';
export const RemoveMembersRoles = 'removeMembersRoles';
export const FetchRoles = 'fetchRoles';
export const TransferOwnership = 'transferOwnership';

// PREVIEW ACTIONS
export const StartPreview = 'startPreview';
export const SetupPreview = 'setupPreview';
export const StopPreview = 'stopPreview';

// PLUGIN ACTIONS
export const FetchPlugins = 'fetchPlugins';
export const GetPluginById = 'getPluginById';
export const UpdatePlugin = 'updatePlugin';

// CREATE AMP WIZARD
export const ClearUploadFile = 'clearUploadFile';
export const StartFileUpload = 'startFileUpload';
export const ResetUploadStep = 'resetUploadStep';

// NOTIFICATIONS
export const ClearNotificationById = 'clearNotificationById';
export const ClearAllNotifications = 'clearAllNotifications';
export const MarkNotificationAsReadById = 'markNotificationAsReadById';
export const MarkAllNotificationsAsRead = 'markAllNotificationsAsRead';

// INSIGHTS
export const FetchSessionInsights = 'fetchAmpInsights';
export const GenerateCsvReport = 'generateCsvReport';

// CRM
export const SaveCrmConnector = 'saveCrmConnector';
export const FetchCrmConnector = 'fetchCrmConnector';
export const FetchAccountKeys = 'fetchAccountKeys';
